import React from "react";
import { Card, Box, useTheme } from "@mui/material";
import { Draggable } from "react-beautiful-dnd";

export default function Feld(props) {
  const { id, feld, index, onClick, liste } = props;
  const theme = useTheme();
  function getColor(dragging) {
    if (dragging) {
      if (feld.art === "E") return { backgroundColor: theme.palette.blocks.lightred };
      if (feld.art === "G") return { backgroundColor: theme.palette.blocks.lightgreen };
      if (feld.art === "V") return { backgroundColor: theme.palette.blocks.orange };
      if (feld.art === "I") return { backgroundColor: theme.palette.blocks.lightblue };
      if (feld.art === "S") return { backgroundColor: theme.palette.blocks.lightyellow };
      if (feld.art === "R") return { backgroundColor: theme.palette.blocks.lightpurple };
      if (feld.art === "D") return { backgroundColor: theme.palette.blocks.lightyellow };
      if (feld.art === "P") return { backgroundColor: theme.palette.blocks.lightpink };
    } else {
      if (feld.art === "E") return { backgroundColor: theme.palette.blocks.red };
      if (feld.art === "G") return { backgroundColor: theme.palette.blocks.green };
      if (feld.art === "V") return { backgroundColor: theme.palette.blocks.orange };
      if (feld.art === "I") return { backgroundColor: theme.palette.blocks.blue };
      if (feld.art === "S") return { backgroundColor: theme.palette.blocks.yellow };
      if (feld.art === "R" && feld.typ === "07") return { backgroundColor: theme.palette.blocks.purple, opacity: "50%" };
      if (feld.art === "R") return { backgroundColor: theme.palette.blocks.purple };
      if (feld.art === "D") return { backgroundColor: theme.palette.blocks.yellow };
      if (feld.art === "P") return { backgroundColor: theme.palette.blocks.teal };
    }
  }

  return (
    <Draggable key={id} draggableId={id} index={index}>
      {(provided, snapshot) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <Box p={0.5}>
            <Card {...provided.dragHandleProps} style={getColor(snapshot.isDragging)} onClick={(e) => onClick(e, feld, liste, index)}>
              <Box p={0.1}>
                {feld.art === "I" && liste.length >= 4 && liste.substr(0, 1) === "G"
                  ? feld.inhalt.length > 100
                    ? feld.name + " - " + feld.inhalt.substr(0, 100)
                    : feld.name + " - " + feld.inhalt
                  : feld.name}
              </Box>
            </Card>
          </Box>
        </div>
      )}
    </Draggable>
  );
}
